module.exports = __webpack_public_path__ + "img/9.205157a9.png";